import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentCancel = () => (
  <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6 paper-texture">
    <div className="w-full max-w-md text-center">
      <div className="inline-flex items-center gap-2 mb-8">
        <BookOpen className="w-8 h-8 text-[#6B7A4F]" />
        <span className="text-2xl font-bold text-[#2D2A26]">Bookish Bestie</span>
      </div>
      <div className="glass-card p-10 rounded-2xl">
        <XCircle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-[#2D2A26] mb-2">Payment Cancelled</h2>
        <p className="text-[#5C5955] mb-6">No worries! Your account is still ready when you are.</p>
        <div className="space-y-3">
          <Link to="/checkout" className="block">
            <Button className="w-full bg-[#6B7A4F] hover:bg-[#57653F] text-white rounded-full py-6">
              Complete Payment
            </Button>
          </Link>
          <Link to="/dashboard" className="text-sm text-[#5C5955] hover:text-[#6B7A4F]">
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default PaymentCancel;
